import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useUser, SignInButton } from '@clerk/clerk-react';

export default function RmaQrRedirect() {
  const { rmaId } = useParams();
  const { isSignedIn, isLoaded } = useUser();

  if (!isLoaded) return null;

  if (isSignedIn) {
    const target = rmaId ? `/rma-archive?rmaId=${encodeURIComponent(rmaId)}` : '/rma-archive';
    return <Navigate to={target} replace />;
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      gap: '1.5rem',
      padding: '2rem',
      textAlign: 'center',
      background: '#0d1117'
    }}>
      <img src="/north-invent-logo.svg" alt="North Invent" style={{ height: '48px', opacity: 0.9 }} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        <h2 style={{ margin: 0, color: '#f9fafb', fontSize: '1.4rem', fontWeight: 600 }}>
          RMA Record
        </h2>
        {rmaId && (
          <span style={{ color: '#9ca3af', fontSize: '0.9rem', fontFamily: 'monospace' }}>
            {rmaId}
          </span>
        )}
      </div>
      <p style={{ color: '#9ca3af', margin: 0, maxWidth: '320px', lineHeight: 1.6 }}>
        Sign in to view the archived RMA details for this case.
      </p>
      <SignInButton mode="modal" afterSignInUrl={rmaId ? `/rma-archive?rmaId=${encodeURIComponent(rmaId)}` : '/rma-archive'}>
        <button className="ni-button ni-button--primary" style={{ fontSize: '1rem', padding: '0.65rem 2rem' }}>
          Sign in
        </button>
      </SignInButton>
    </div>
  );
}
